import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { locales } from "../../locales";
import { formatString } from "../../utils/communesUtils";

ChartJS.register(ArcElement, Tooltip, Legend);

const colors = {
  deigreng: "#39B54A",
  lsap: "#F00035",
  csv: "#FFCC00",
  dp: "#002C4F",
  arleit: "#FF6600",
  deilenk: "#e10736",
  kpl: "#FF0000",
  ebl: "#0FA6A6",
  adr: "#b8def1",
  biergerlest: "#653796",
  schetterbierger: "#653796",
  arequipe: "#8A365D",
  piraten: "#a62a8c",
  piratepartei: "#a62a8c",
  schetter: "#662e88",
  biergerlestgemengcliarref: "#eaca87",
  dleschtvundebierger: "#eaca87",
  dineiekipp: "#eeaa87",
  engageiertbiergerlentgen: "#eaca33",
  aerekipp: "#aaaa87",
  besserzesummen: "#eaca43",
  arequipefirdwormergemeen: "#8A365D",
  zesummenfirisgemeen: "#eaca78",
  fraileschtarleitfirrouspertmompech: "#eaca12",
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 3,
  },
  tooltips: {
    enabled: false,
  },
  plugins: {
    legend: {
      labels: {
        boxWidth: 31,
        boxHeight: 23,
        color: "#000",
      },
      display: true,
      position: "bottom",
      align: "start",
    },
  },
};

const optionsDesktop = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: 0,
  },
  tooltips: {
    enabled: false,
  },
  plugins: {
    legend: {
      labels: {
        boxWidth: 16,
        boxHeight: 16,
        color: "#000",
      },
      display: true,
      position: "bottom",
      align: "start",
    },
  },
};

// plugins
// const doughnutLabelsLine = {
//   id: "doughnutLabelsLine",
//   afterDraw: (chart, args, options) => {
//     const {
//       ctx,
//       chartArea: { width, height },
//     } = chart;

//     chart.data.datasets.forEach((dataset, i) => {
//       chart.getDatasetMeta(i).data.forEach((datapoint, j) => {
//         const { x, y } = datapoint.tooltipPosition();

//         // draw line to label text
//         const halfWidth = width / 2;
//         const halfHeight = height / 2;
//         const xLine = x >= halfWidth ? x + 50 : x - 50;
//         const yLine = y >= halfHeight ? y + 15 : y - 15;
//         const extraLine = x >= halfWidth ? 15 : -15;

//         // line from datapoint to label text
//         ctx.beginPath();
//         ctx.moveTo(x, y);
//         ctx.lineTo(xLine, yLine);
//         ctx.lineTo(xLine + extraLine, yLine);
//         ctx.strokeStyle = dataset.backgroundColor[j];
//         ctx.stroke();

//         // control the position of the text
//         const textXPosition = x >= halfWidth ? "left" : "right";
//         const plusFivePx = x >= halfWidth ? 5 : -5;
//         // const numberOfSeats = dataset.data[j];
//         ctx.font = "12px Fira Sans Condensed";
//         ctx.textAlign = textXPosition;
//         ctx.textBaseline = "middle";
//         ctx.fillText(
//           chart.data.labels[j],
//           xLine + extraLine + plusFivePx,
//           yLine
//         );
//       });
//     });
//   },
// };

const MunicipalCouncil = ({ data, isDesktop, langId }) => {
  // for (const key in data) {
  //   console.log("====================================");
  //   console.log(formatString(key));
  //   console.log("====================================");
  // }

  // Sort the data object by value (in descending order)
  const sortedDataArray = Object.entries(data).sort(
    ([, valueA], [, valueB]) => valueB - valueA
  );

  // Convert the sorted array back to an object
  const sortedData = Object.fromEntries(sortedDataArray);

  const filteredData = Object.fromEntries(
    Object.entries(sortedData).filter(([key, value]) => value !== 0)
  );

  const labels = Object.keys(filteredData).filter(
    (label) => formatString(label) in colors
  );
  const inputObject = labels.map((label) => filteredData[label]);
  const backgroundColor = labels.map((label) => colors[formatString(label)]);
  const labelWithValues = labels.map(
    (label) => label + " (" + filteredData[label].toString() + ")"
  );

  const chartObject = {
    labels: labelWithValues,
    datasets: [
      {
        label: locales[langId].numberOfSeats,
        data: inputObject,
        backgroundColor: backgroundColor,
        borderWidth: 1,
      },
    ],
  };

  return (
    <Doughnut
      data={chartObject}
      options={isDesktop ? optionsDesktop : options}
      // plugins={isDesktop ? [doughnutLabelsLine] : []}
    />
  );
};

export default MunicipalCouncil;
